export function delay(timeout: number): Promise<void> {
    return new Promise(resolve => {
        setTimeout(resolve, timeout);
    });
}

export function nextTick(): Promise<void> {
    return new Promise(resolve => {
        setTimeout(resolve, 0);
    });
}
